import { RadioGroup, Text } from 'components'
import { formTextProps } from '../../utils'
import FormSection from '../FormSection'

interface Props {
  previewMode?: boolean
  colorScheme?: string
  text?: string
  value?: string
  onChange: (value: string) => void
}

export default function RegionSection({ previewMode, colorScheme, text, value, onChange }: Props) {
  const defaultText = 'Do you reside in the United States?'
  return (
    <FormSection key="region" previewMode={previewMode}>
      <Text {...formTextProps}>{text ?? defaultText}</Text>
      <RadioGroup
        value={value}
        options={[{ value: 'yes' }, { value: 'no' }]}
        onChange={onChange}
        textProps={formTextProps}
        colorPalette={colorScheme}
      />
    </FormSection>
  )
}
